import constantCreator from 'utils/constantCreator';
import api from 'utils/api';

const define = constantCreator('affiliate');
const GET_AFFILIATE_REPORT = define('GET_AFFILIATE_REPORT', true);
const GET_AFFILIATE_PAYMENT = define('GET_AFFILIATE_PAYMENT', true);
const MANAGE_HOLD = define('MANAGE_HOLD', true);
const PAID_TRANSACTIONS = define('PAID_TRANSACTIONS', true);
const UNAPPROVE_TRANSACTION = define('UNAPPROVE_TRANSACTION', true);
const GET_AFFILIATE_USERS = define('GET_AFFILIATE_USERS', true);
const SET_AFFILIATE_USERS = define('SET_AFFILIATE_USERS', true);
const GET_PAYMENT_ACCOUNT = define('GET_PAYMENT_ACCOUNT', true);
const SET_PAYMENT_ACCOUNT = define('SET_PAYMENT_ACCOUNT', true);
const GET_TRANSACTION_DETAIL = define('GET_TRANSACTION_DETAIL', true);
const SET_ADJUSTMENT = define('SET_ADJUSTMENT', true);
const GET_AFFILIATE_DETAIL = define('GET_AFFILIATE_DETAIL', true);
const SET_INTERNAL_NOTE = define('SET_INTERNAL_NOTE', true);
const SET_WHITE_LABEL = define('SET_WHITE_LABEL', true);

const initialState = {
  isLoading: true,
  reports: [],
  payments: [],
  newUsers: [],
  users: [],
  affiliateDetail: {},
  paymentAccount: {},
  transactionDetail: {}
};

export default (state = initialState, action) => {
  switch (action.type) {
    case GET_AFFILIATE_REPORT.PENDING:
      return {
        ...state,
        isLoading: true,
      };
    case GET_AFFILIATE_REPORT.RESOLVED:
      return {
        ...state,
        isLoading: false,
        reports: action.data
      };
    case GET_AFFILIATE_REPORT.REJECTED:
      return {
        ...state,
        isLoading: true,
      };
    case GET_AFFILIATE_PAYMENT.PENDING:
      return {
        ...state,
        ...action.noLoad ? { } : { isLoading: true }
      };
    case GET_AFFILIATE_PAYMENT.RESOLVED:
      return {
        ...state,
        isLoading: false,
        payments: action.data
      };
    case GET_AFFILIATE_PAYMENT.REJECTED:
      return {
        ...state,
        isLoading: true,
        ...action.noLoad ? { } : { isLoading: true }
      };
    case MANAGE_HOLD.PENDING:
      return {
        ...state,
        isLoading: true,
      };
    case MANAGE_HOLD.RESOLVED:
      return {
        ...state,
        isLoading: false,
      };
    case MANAGE_HOLD.REJECTED:
      return {
        ...state,
        isLoading: true,
      };
    case PAID_TRANSACTIONS.PENDING:
      return {
        ...state,
        isLoading: true,
      };
    case PAID_TRANSACTIONS.RESOLVED:
      return {
        ...state,
        isLoading: false,
      };
    case PAID_TRANSACTIONS.REJECTED:
      return {
        ...state,
        isLoading: true,
      };
    case GET_AFFILIATE_USERS.PENDING:
      return {
        ...state,
        isLoading: true,
      };
    case GET_AFFILIATE_USERS.RESOLVED:
      return {
        ...state,
        isLoading: false,
        users: action.data.users,
        newUsers: action.data.new_users,
      };
    case GET_AFFILIATE_USERS.REJECTED:
      return {
        ...state,
        isLoading: true,
      };
    case GET_AFFILIATE_DETAIL.PENDING:
      return {
        ...state,
        isLoading: true,
      };
    case GET_AFFILIATE_DETAIL.RESOLVED:
      return {
        ...state,
        isLoading: false,
        affiliateDetail: action.data,
      };
    case GET_AFFILIATE_DETAIL.REJECTED:
      return {
        ...state,
        isLoading: true,
      };
    case SET_AFFILIATE_USERS.PENDING:
      return {
        ...state,
        isLoading: true,
      };
    case SET_AFFILIATE_USERS.RESOLVED:
      return {
        ...state,
        isLoading: false,
      };
    case SET_AFFILIATE_USERS.REJECTED:
      return {
        ...state,
        isLoading: true,
      };
    case GET_PAYMENT_ACCOUNT.PENDING:
      return {
        ...state,
        loading: true,
        paymentAccount: {},
      };
    case GET_PAYMENT_ACCOUNT.RESOLVED:
      return {
        ...state,
        paymentAccount: action.data,
        loading: false,
      };
    case GET_PAYMENT_ACCOUNT.REJECTED:
      return {
        ...state,
        loading: false,
      };
    case GET_TRANSACTION_DETAIL.PENDING:
      return {
        ...state,
        loading: true,
        transactionDetail: {},
      };
    case GET_TRANSACTION_DETAIL.RESOLVED:
      return {
        ...state,
        transactionDetail: action.data,
        loading: false,
      };
    case GET_TRANSACTION_DETAIL.REJECTED:
      return {
        ...state,
        loading: false,
      };
    case SET_ADJUSTMENT.PENDING:
      return {
        ...state,
        loading: true,
      };
    case SET_ADJUSTMENT.RESOLVED:
      return {
        ...state,
        loading: false,
      };
    case SET_ADJUSTMENT.REJECTED:
      return {
        ...state,
        loading: false,
      };
    case SET_INTERNAL_NOTE.PENDING:
      return {
        ...state,
        loading: true,
      };
    case SET_INTERNAL_NOTE.RESOLVED:
      return {
        ...state,
        loading: false,
      };
    case SET_INTERNAL_NOTE.REJECTED:
      return {
        ...state,
        loading: false,
      };
    case SET_WHITE_LABEL.PENDING:
      return {
        ...state,
        loading: true,
      };
    case SET_WHITE_LABEL.RESOLVED:
    case SET_WHITE_LABEL.REJECTED:
      return {
        ...state,
        loading: false
      };
    case SET_PAYMENT_ACCOUNT.PENDING:
      return {
        ...state,
        loading: true,
        paymentAccount: {},
      };
    case SET_PAYMENT_ACCOUNT.RESOLVED:
      return {
        ...state,
        paymentAccount: action.data,
        loading: false,
      };
    case SET_PAYMENT_ACCOUNT.REJECTED:
      return {
        ...state,
        loading: false,
      };
    default: return state;
  }
};

export const actions = {
  getAffiliateReport: (from = '', to = '') => ({
    type: GET_AFFILIATE_REPORT,
    promise: api.get(`/affiliate/user?from=${from}&to=${to}`)
  }),
  // since api does not process req.query.year but it use moment format with year so this is a workaround
  getAffiliatePayment: (month = '', year = '', noLoad = false) => ({
    type: GET_AFFILIATE_PAYMENT,
    promise: api.get(`/affiliate/paid?month=${month} ${year}`),
    noLoad
  }),
  paidAffiliateTransaction: (transactions = []) => ({
    type: PAID_TRANSACTIONS,
    promise: api.post('/affiliate/paid', { paid_transactions: transactions }),
    success: 'Paid Transactions',
    error: 'Error Paid Transaction'
  }),
  unapproveAffiliateTransaction: (id) => ({
    type: UNAPPROVE_TRANSACTION,
    promise: api.post('/affiliate/unapprove', { transaction_id: id }),
    success: 'Unapprove Transaction Successful',
    error: 'Fail to unapprove transaction',
  }),
  manageHold: (status, id) => ({
    type: MANAGE_HOLD,
    promise: api.post('/affiliate/process-hold', { status, transaction_id: id }),
    success: `You ${status} Transaction ID ${id}`,
    error: `Error ${status} transaction ID ${id}`
  }),
  getAffiliateUsers: () => ({
    type: GET_AFFILIATE_USERS,
    promise: api.get('/affiliate/users')
  }),
  setAffiliateUsers: (email, affiliateId) => ({
    type: SET_AFFILIATE_USERS,
    promise: api.post('/affiliate/users', { user_email: email, affiliate_id: affiliateId }),
    error: 'Error set affiliate ID'
  }),
  getAffiliateDetail: (id) => ({
    type: GET_AFFILIATE_DETAIL,
    promise: api.get(`/affiliate/detail/${id}`)
  }),
  getPaymentAccount: (id) => ({
    type: GET_PAYMENT_ACCOUNT,
    promise: api.get(`/affiliate/payment-account/${id}`)
  }),
  setPaymentAccount: (id, data) => ({
    type: SET_PAYMENT_ACCOUNT,
    promise: api.post(`/affiliate/payment-account/${id}`, { ...data })
  }),
  getTransactionDetail: (id) => ({
    type: GET_TRANSACTION_DETAIL,
    promise: api.get(`/affiliate/transactions/${id}`)
  }),
  setAdjustment: (id, adjustValue) => ({
    type: SET_ADJUSTMENT,
    promise: api.post(`/affiliate/transactions/${id}`, { data: adjustValue })
  }),
  setInternalNote: (id, internalNote) => ({
    type: SET_INTERNAL_NOTE,
    promise: api.post(`/affiliate/internal-note/${id}`, { internal_note: internalNote })
  }),
  updateWhiteLabel: (userId, logo) => ({ // logo --> { logoDesktop: String, logoDesktop2x: String, logoMobile: String, logoMobile2x: String, logoAlt: String }
    type: SET_WHITE_LABEL,
    promise: api.post(`/affiliate/white-label/${userId}`, logo),
    success: 'White label has been updated',
    error: 'Fail to update white label',
  })
};



// WEBPACK FOOTER //
// ./src/ducks/affiliate.js